export enum OnlineOrderPositionKinds {
  Card = 'Card',
  Voucher = 'Voucher',
  Unknown = 'Unknown'
}
